export default __webpack_public_path__ + "static/media/conectivity.c1ee5f61.svg";